import { clearSessionData } from '../utilities';
import DOMPurify from 'dompurify';
import {parseReturnUrl} from "./ReturnUrlParser";

export const getTextContent = (content: string): string => {
  const clean = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: []
  });
  return clean;
};
export const getTextContentLength = (content: string): number => {
  var textContent = getTextContent(content);
  return textContent?.length ?? 0;
};
export const getQueryParam = (param: string): string => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  return params.get(param);
};
export const bindReturnUrl = (): void => {
  window.localStorage.setItem('redirect_after_login', '1');

  const _url = new URL(window.location.href);
  const return_url = window.localStorage.getItem('return_url');
  if (return_url) {
    window.localStorage.removeItem('return_url');
    parseReturnUrl(return_url);
    return;
  }

  if ((_url.pathname || '/') !== '/') {
    window.location.reload();
    return;
  }

  const banner_link_to = window.localStorage.getItem('banner_link_to');
  if (banner_link_to && isValidUrl(banner_link_to)) {
    window.localStorage.removeItem('banner_link_to');
    window.open(banner_link_to, '_blank');
  }

  window.location.href = '/home';
};

export const doLogout = () => {
  clearSessionData();
  window.location.href = '/';
};

export const sanitizeOriginHostname = (urlOrigin: string): string => {
  let sanitizedUrl = new URL(urlOrigin);
  sanitizedUrl.hostname = sanitizedUrl.hostname.replace(
    /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/,
    ''
  );
  sanitizedUrl.hostname = sanitizedUrl.hostname.replace('newbeelajar', 'beelajar');
  return sanitizedUrl.origin;
};

const isValidUrl = (url) => {
  try {
    new URL(url);
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
};
